import { clsx } from 'clsx';
import { type ReactNode } from 'react';

import s from './RadioButton.module.css';
import { Flex } from '@repo/ui/Flex';
import { Radio, type RadioProps } from '@repo/ui/Radio';

export type RadioButtonProps = RadioProps & {
  children: ReactNode;
  appendedChildren?: ReactNode;
  className?: string;
};

export const RadioButton = (props: RadioButtonProps) => {
  const { className, children, appendedChildren, ...restProps } = props;

  return (
    <div className={clsx(s.container, className)}>
      <label>
        <Flex gap="g-16" alignItems="center">
          <Radio {...restProps} />
          {children}
        </Flex>
      </label>
      {appendedChildren}
    </div>
  );
};
